import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentYear = new Date().getFullYear();

  quickLinks = [
    { label: 'Home', route: '/', fragment: undefined },
    { label: 'Offerta', route: '/', fragment: 'offerta' },
    { label: 'Chi siamo', route: '/', fragment: 'chi-siamo' },
    { label: 'Contatti', route: '/', fragment: 'contatti' }
  ];

  socialLinks = [
    { icon: 'fab fa-facebook-f', url: '#', label: 'Facebook' },
    { icon: 'fab fa-twitter', url: '#', label: 'Twitter' },
    { icon: 'fab fa-linkedin-in', url: '#', label: 'LinkedIn' },
    { icon: 'fab fa-instagram', url: '#', label: 'Instagram' }
  ];

  ngOnInit(): void {
    this.loadIubendaScript();
  }

  private loadIubendaScript(): void {
    // Iubenda script loader
    const loader = () => {
      const script = document.createElement('script');
      const tag = document.getElementsByTagName('script')[0];
      script.src = 'https://cdn.iubenda.com/iubenda.js';
      tag.parentNode?.insertBefore(script, tag);
    };

    if (window.addEventListener) {
      window.addEventListener('load', loader, false);
    } else if ((window as any).attachEvent) {
      (window as any).attachEvent('onload', loader);
    } else {
      window.onload = loader;
    }
  }
}

